<div class="col col-md-8 col-sm-10 col-xs-12">
  <div class="card">
    <div class="card-header">Registro de usuarios/as</div>
    <div class="card-body">
      <form (submit)="onSubmit(signupForm)" #signupForm="ngForm">
        <div class="row">
          <div class="col">
            <div class="mb-3">
              <label class="form-label">Nombre:</label>
              <input
                type="text"
                class="form-control"
                name="firstname"
                ngModel
                #firstnameInput="ngModel"
                required
              />
              <p
                class="text-danger p-3 px-0"
                *ngIf="!firstnameInput.pristine && firstnameInput.invalid"
              >
                Por favor, introduzca un nombre válido.
              </p>
            </div>

            <div class="mb-3">
              <label class="form-label">Apellido(s):</label>
              <input
                type="text"
                class="form-control"
                name="surname"
                ngModel
                #surnameInput="ngModel"
                required
              />
              <p
                class="text-danger p-3 px-0"
                *ngIf="!surnameInput.pristine && surnameInput.invalid"
              >
                Por favor, introduzca un apellido/s válido.
              </p>
            </div>
            <div class="mb-3">
              <label class="form-label">E-mail:</label>
              <input
                type="email"
                class="form-control"
                name="email"
                ngModel
                #emailInput="ngModel"
                required
                email
              />
              <p
                class="text-danger p-3 px-0"
                *ngIf="!emailInput.pristine && emailInput.invalid"
              >
                Por favor, introduzca una dirección de e-mail válida.
              </p>
            </div>
            <div class="mb-3">
              <label class="form-label">Contraseña:</label>
              <input
                type="password"
                class="form-control"
                name="password"
                ngModel
                #passwordInput="ngModel"
                required
              />
              <p
                class="text-danger p-3 px-0"
                *ngIf="!passwordInput.pristine && passwordInput.invalid"
              >
                Por favor, introduzca una contraseña válida.
              </p>
            </div>
            <div class="mb-3">
              <label class="form-label">Confirmar contraseña:</label>
              <input
                type="password"
                class="form-control"
                name="repeatPassword"
                ngModel
                #repeatPasswordInput="ngModel"
                required
              />
              <p
                class="text-danger p-3 px-0"
                *ngIf="
                  !repeatPasswordInput.pristine && repeatPasswordInput.invalid
                "
              >
                Por favor, introduzca una contraseña válida.
              </p>
              <p
                class="text-danger p-3 px-0"
                *ngIf="
                  !repeatPasswordInput.pristine &&
                  !passwordInput.pristine &&
                  passwordInput.value != repeatPasswordInput.value
                "
              >
                Las contraseñas no coinciden.
              </p>
            </div>

            <div class="mb-3 form-check">
              <input
                type="checkbox"
                class="form-check-input"
                name="privacy"
                ngModel
                #privacyInput="ngModel"
                required
              />
              <label class="form-check-label" required>
                Acepto la política de privacidad
                <span class="text-danger">*</span>
              </label>
            </div>
          </div>

          <div class="col text-muted lh-sm text-justify px-4">
            <small
              ><span class="text-danger">*</span> En cumplimiento con el
              <i>Reglamento General de Protección de Datos</i> (RGPD) de 2018 y
              la
              <i>Ley de Protección de Datos y Garantía de Derechos Digitales</i>
              (LOPDGDD) de 2018, le informamos que los datos de carácter
              personal que proporcione rellenando el presente formulario serán
              <strong>tratados</strong> por D. FRANCISCO JOSÉ CABALLERO CEREZO
              como responsable temporal de esta web. La
              <strong>finalidad</strong> de la recogida y tratamiento de los
              datos personales es establecer acceso a la interfaz de gestión de
              cocina sin recetas y recoger datos de uso. La
              <strong>legitimación</strong> se realiza a través del
              consentimiento del interesado. Los datos estarán
              <strong strong>ubicados</strong> de forma cifrada en un servidor
              seguro de OVH HISPANO, S.L.U. Podrá ejercer sus
              <strong>derechos</strong> de acceso, rectificación, limitación y
              supresión de los datos contactando a
              INFO@FRANCABALLERO.NET.</small
            >
          </div>
        </div>
        <div class="col-12 text-center p-4 px-0">
          <button
            *ngIf="!isLoading"
            type="submit"
            class="btn btn-primary"
            [disabled]="
              (signupForm.invalid &&
                (passwordInput.value != repeatPasswordInput.value ||
                  emailInput.invalid)) ||
              !privacyInput.value
            "
          >
            Registrarse
          </button>
          <p *ngIf="isLoading">Cargando...</p>
        </div>
      </form>
    </div>
  </div>
</div>
